import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { MatSpinnerOverlayComponent } from '../../components/mat-spinner-overlay/mat-spinner-overlay.component';
import { IFrotaModel } from '../../frota/model/frota.model';
import { FiltrarFrotaComponent } from '../../rede-especial/filtrar-frota/filtrar-frota.component';
import { AcordosExistentesComponent } from '../acordos-existentes/acordos-existentes.component';
import {
  AcordoModel,
  CombustivelContrato,
  PayloadCriarAcordo,
} from '../rede-especial.interface';
import { RedeEspecialService } from '../rede-especial.service';

@Component({
  selector: 'app-criar-novo-acordo',
  templateUrl: './criar-novo-acordo.component.html',
  styleUrls: ['./criar-novo-acordo.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NgIf,
    NgFor,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatTooltipModule,
    CurrencyMaskModule,
    AcordosExistentesComponent,
    MatSpinnerOverlayComponent,
  ],
})
export class CriarNovoAcordoComponent {
  public dialog = inject(MatDialog);
  public loading = false;
  frotaSelecionada!: IFrotaModel;
  acordosExistentes: AcordoModel[] = [];
  msgAcordosExistentes: string = '';
  combustiveis: CombustivelContrato[] = [];

  acordosForm: FormGroup = new FormGroup({
    buscaFrota: new FormControl('', [Validators.required]),
    codFrota: new FormControl('', [Validators.required]),
    tipo: new FormControl(null, [Validators.required]),
    combustivel: new FormControl(null, [Validators.required]),
    valorFixo: new FormControl(null),
    valorDescontoEmReais: new FormControl(null),
  });

  constructor(
    public dialogRef: MatDialogRef<CriarNovoAcordoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CombustivelContrato[],
    private service: RedeEspecialService,
    private snackBar: SnackBarService
  ) {
    this.combustiveis = data;
    console.log('combustiveis', this.combustiveis);
  }

  onTipoChange(event: any) {
    console.log('event', event);
    this.acordosForm.get('valorFixo')?.clearValidators();
    this.acordosForm.get('valorDescontoEmReais')?.clearValidators();

    switch (event.value) {
      case '2':
        this.acordosForm.get('valorFixo')?.setValidators([Validators.required]);
        this.acordosForm.get('valorDescontoEmReais')?.setValue('');
        break;
      case '5':
        this.acordosForm
          .get('valorDescontoEmReais')
          ?.setValidators([Validators.required]);
        this.acordosForm.get('valorFixo')?.setValue('');
        break;
    }
    this.acordosForm.get('valorFixo')?.updateValueAndValidity();
    this.acordosForm.get('valorDescontoEmReais')?.updateValueAndValidity();
  }

  limparDadosFrota() {
    this.acordosForm.get('buscaFrota')?.setValue('');
    this.frotaSelecionada = null as any;
  }

  gerenciarRetornoDialog(frota: IFrotaModel) {
    if (frota) {
      this.frotaSelecionada = frota;
      this.acordosForm.get('codFrota')?.setValue(frota.codigo);
      this.acordosForm.get('buscaFrota')?.setErrors(null);
    } else {
      this.limparDadosFrota();
    }
  }

  onCancelar(): void {
    this.dialogRef.close(false);
  }
  verificarCliqueLupa() {
    console.log('verificarCliqueLupa');
    if (
      this.acordosForm.get('buscaFrota')?.value &&
      this.acordosForm.get('buscaFrota')?.value !== '' &&
      this.acordosForm.get('codFrota')?.value === ''
    ) {
      // definir buscaFrota como tendo erro e motrar no formulário
      this.acordosForm.get('buscaFrota')?.setErrors({ required: true });
    }
  }
  openDialog() {
    if (this.acordosForm.get('buscaFrota')?.value) {
      const dialogRef = this.dialog.open(FiltrarFrotaComponent, {
        width: '70%',
        data: this.acordosForm.get('buscaFrota')?.value,
      });

      dialogRef.afterClosed().subscribe((result: IFrotaModel) => {
        this.gerenciarRetornoDialog(result);
      });
    }
  }

  private async enviarPayloadAcordo(payload: PayloadCriarAcordo) {
    this.loading = true;

    this.service.criarNovoAcordo(payload).subscribe({
      next: (res) => {
        if (res.sucesso) {
          this.snackBar.flashMessage(
            `Acordo #${res.retorno} criado com sucesso!`,
            ['snackbar-success'],
            'Fechar',
            2
          );
          this.dialogRef.close({ sucesso: true });
        } else {
          this.msgAcordosExistentes = res.mensagens[0];
          this.acordosExistentes = res.retorno;

          this.snackBar.flashMessage(
            res.mensagens[0],
            ['snackbar-error'],
            'Fechar',
            2
          );
          this.dialogRef.close({ sucesso: false });
        }
      },
      error: (err) => {
        this.dialogRef.close({ sucesso: false });
        this.snackBar.flashMessage(
          'Erro ao criar acordo!',
          ['snackbar-error'],
          'Fechar',
          2
        );
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  getCombustivelByCodigo(codigo: number): CombustivelContrato | undefined {
    console.log('getCombustivelByCodigo', codigo);
    console.log(this.combustiveis);
    return this.combustiveis.find((c) => c.codigoCombustivel === codigo);
  }

  isFormValid(): boolean {
    if (!this.acordosForm.valid) {
      return false;
    }
    const valorFixo = this.acordosForm.get('valorFixo')?.value;
    const valorDescontoEmReais = this.acordosForm.get(
      'valorDescontoEmReais'
    )?.value;
    if (!valorFixo && !valorDescontoEmReais) {
      return false;
    }

    const tipo = this.acordosForm.get('tipo')?.value;
    if (tipo === '2' && !this.acordosForm.get('valorFixo')?.value) {
      return false;
    }
    if (tipo === '5' && !this.acordosForm.get('valorDescontoEmReais')?.value) {
      return false;
    }
    return true;
  }

  onConfirmar(): void {
    if (!this.acordosForm.valid) {
      this.snackBar.flashMessage(
        'Preencha todos os campos obrigatórios.',
        ['snackbar-error'],
        'Fechar',
        2
      );
      return;
    }
    this.loading = true;
    const result = this.acordosForm.value;

    const codCombustivel = this.getCombustivelByCodigo(result.combustivel);

    const payload = {
      codFrota: result.codFrota,
      combustivel: result.combustivel,
      indCombustivel: codCombustivel?.descricaoCombustivel || '',
      tipo: result.tipo,
      valorFixo: result.valorFixo == '' ? null : parseFloat(result.valorFixo),
      valorDescontoEmReais:
        result.valorDescontoEmReais == ''
          ? null
          : parseFloat(result.valorDescontoEmReais),
    };

    this.enviarPayloadAcordo(payload);
  }
}
